// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ic","header":"id","overTitle":"ie","image":"if","title":"ih","description":"ii","email":"ij","button":"ik"};